import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { FaEnvelope } from 'react-icons/fa';

// ═══════════════════════════════════════════════════════════════════════
//  ⚠️ VÉRIFIE L'IMPORT DE L'API (ligne 3) :
//     import api from '../services/api';
//  Remplace le chemin si ton instance axios est ailleurs (ex : '../api',
//  '../utils/api'). Regarde en haut de ton Login.js comment il importe l'API
//  et copie le même import ici et dans ReinitialiserMotDePasse.js.
// ═══════════════════════════════════════════════════════════════════════

const MotDePasseOublie = () => {
    const [email, setEmail] = useState('');
    const [envoye, setEnvoye] = useState(false);
    const [erreur, setErreur] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErreur('');
        setLoading(true);
        try {
            await api.post('/auth/forgot-password', { email });
            setEnvoye(true);
        } catch (err) {
            // Message neutre : on n'indique pas si l'email existe
            setErreur("Une erreur est survenue. Veuillez réessayer dans un instant.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <h1 style={styles.title}>Mot de passe oublié</h1>

                {envoye ? (
                    <p style={styles.success}>
                        Si cette adresse est associée à un compte, un email de réinitialisation
                        vient d'être envoyé. Pensez à vérifier vos spams.
                    </p>
                ) : (
                    <>
                        <p style={styles.subtitle}>
                            Saisissez votre adresse email. Si un compte existe, vous recevrez un lien
                            pour choisir un nouveau mot de passe.
                        </p>

                        {erreur && <div style={styles.error}>{erreur}</div>}

                        <form onSubmit={handleSubmit}>
                            <label style={styles.label}>Adresse email</label>
                            <div style={styles.inputWrap}>
                                <FaEnvelope style={styles.inputIcon} />
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="nom@domaine.com"
                                    required
                                    style={styles.input}
                                />
                            </div>

                            <button type="submit" disabled={loading} style={styles.button}>
                                {loading ? 'Envoi...' : 'Envoyer le lien'}
                            </button>
                        </form>
                    </>
                )}

                <p style={styles.backLink}>
                    <Link to="/login" style={styles.link}>← Retour à la connexion</Link>
                </p>
            </div>
        </div>
    );
};

const styles = {
    page: {
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #fdf2f8 0%, #fce4ef 100%)', padding: '20px',
        fontFamily: 'Arial, sans-serif',
    },
    card: {
        background: '#fff', borderRadius: '20px', padding: '40px 32px',
        boxShadow: '0 8px 30px rgba(120,24,64,0.12)', maxWidth: '420px', width: '100%',
    },
    title: {
        color: '#781840', fontSize: '26px', fontWeight: '700', margin: '0 0 12px', textAlign: 'center',
        fontFamily: 'Cormorant Garamond, serif',
    },
    subtitle: { color: '#7a6570', fontSize: '14px', lineHeight: '1.6', margin: '0 0 24px', textAlign: 'center' },
    success: {
        color: '#2c5f2e', fontSize: '14px', lineHeight: '1.7', textAlign: 'center',
        background: '#eaf6ea', padding: '16px', borderRadius: '10px', margin: '0 0 20px',
    },
    error: {
        color: '#b3123b', fontSize: '13px', background: '#fdeaef',
        padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', textAlign: 'center',
    },
    label: { display: 'block', color: '#4a3540', fontSize: '13px', fontWeight: '600', marginBottom: '6px' },
    inputWrap: { position: 'relative', marginBottom: '20px' },
    inputIcon: { position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#c0306a', fontSize: '14px' },
    input: {
        width: '100%', padding: '12px 12px 12px 40px', border: '1.5px solid #f0d9e5',
        borderRadius: '10px', fontSize: '14px', boxSizing: 'border-box', outline: 'none',
    },
    button: {
        width: '100%', padding: '13px', background: '#781840', color: '#fff', border: 'none',
        borderRadius: '10px', fontSize: '15px', fontWeight: '700', cursor: 'pointer',
    },
    backLink: { textAlign: 'center', marginTop: '22px', marginBottom: 0 },
    link: { color: '#c0306a', fontSize: '13px', textDecoration: 'none', fontWeight: '600' },
};

export default MotDePasseOublie;